import omit from 'lodash/omit';

import { Concept } from '../models/document';

export const omitTypeFromConcepts = (concepts: Concept[]) => {
  return concepts.map((concept) => {
    return omit(concept, ['type', 'totalWithoutTaxes']);
  });
};
